<script>
  import ImageLoader from "./ImageLoader.svelte";

  export let year;

  const TEST_MODE = false;

  const counts = {
    2021: 130,
    2023: 226,
    2024: 16,
    2025: 20,
  };

  $: count = counts[year];
  $: list = [...Array(count).keys()];
  //   The indexes I want to keep from the $list.
  $: keep =
    year === "2023"
      ? [
          179, 0, 3, 11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 34, 31, 39, 48, 50,
          58, 60, 61, 64, 53, 67, 69, 71, 75, 76, 78, 80, 87, 95, 96, 99, 111,
          114, 116, 117, 121, 122, 123, 125, 127, 131, 134, 135, 137, 138, 142,
          145, 151, 169, 171, 174, 175, 180, 183, 190, 193, 194, 208, 209, 211,
          3, 23, 37, 43, 45, 72, 112, 118, 130, 148, 162, 178, 191, 224, 196,
        ].map((i) => i + 1)
      : year === "2021"
        ? list.filter((i) => ![86, 125, 127].includes(i))
        : list.map((i) => i + 1);
  $: tallIdx =
    year === "2023"
      ? [
          0, 21, 75, 76, 78, 87, 116, 131, 137, 162, 169, 171, 174, 183, 190,
          193, 194, 209, 224, 208, 211,
        ].map((i) => i + 1)
      : year === "2021"
        ? [
            3, 10, 11, 13, 14, 15, 16, 20, 21, 23, 24, 25, 27, 28, 29, 30, 31,
            32, 36, 40, 41, 43, 46, 48, 50, 51, 53, 54, 58, 59, 60, 61, 62, 65,
            66, 68, 69, 73, 74, 76, 80, 81, 82, 84, 87, 88, 91, 95, 97, 100,
            101, 105, 108, 112, 116, 117, 118, 119, 120, 126, 124, 128, 129,
          ]
        : year === "2025"
          ? [5, 11, 12, 14, 16, 17, 18, 19]
          : year === "2024"
            ? [4, 7, 8, 10, 11, 12, 13, 14, 15, 16]
            : [];

  $: tall = tallIdx.map((idx) => `/g/images/gallery/${year}/${idx}.jpeg`);

  $: getWide = () => {
    if (TEST_MODE) {
      return list.map((i) => `/g/images/gallery/${year}/${i}.jpeg`);
    }
    console.log(list, keep, tallIdx);
    return keep
      .filter((i) => !tallIdx.includes(i))
      .map((i) => `/g/images/gallery/${year}/${i}.jpeg`);
  };

  let toKeep = [
    179, 0, 8, 11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 34, 31, 39, 48, 50, 58,
    60, 61, 64, 53, 67, 69, 71, 75, 76, 78, 80, 87, 95, 96, 99, 111, 114, 116,
    117, 121, 122, 123, 125, 127, 131, 134, 135, 137, 138, 142, 145, 151, 169,
    171, 174, 175, 180, 183, 190, 193, 194, 205, 208, 209, 211, 3, 23, 37, 43,
    45, 72, 112, 118, 130, 148, 162, 178, 191, 196,
  ];

  const toggleKeepImage = (idx) => {
    if (toKeep.includes(idx)) {
      toKeep = toKeep.filter((i) => i !== idx);
    } else {
      toKeep = [...toKeep, idx];
    }
  };

  $: isKept = (idx) => {
    return TEST_MODE ? toKeep.includes(idx) : false;
  };

  $: {
    if (TEST_MODE) {
      console.log(toKeep);
    }
  }
</script>

<div class="ph3 pb3 ph5-ns pb5-ns pt3">
  {#each getWide() as src, i}
    <div class="w-100 w-third-ns dib pr3-ns pb3">
      <ImageLoader
        css={isKept(i) ? "ba b--orange bw2" : ""}
        {src}
        alt={`photo`}
        onClick={() => toggleKeepImage(i)}
      />
      {#if TEST_MODE}
        <span>{i + 1}</span>
      {/if}
    </div>
  {/each}
  {#each tall as src, i}
    <div class="w-100 w-third-ns dib pr3-ns pb3">
      <ImageLoader {src} alt={`photo`} onClick={() => toggleKeepImage(i)} />
    </div>
  {/each}
</div>
